import { render, staticRenderFns } from "./Surgery.vue?vue&type=template&id=f6abe830&scoped=true"
import script from "./Surgery.vue?vue&type=script&lang=js"
export * from "./Surgery.vue?vue&type=script&lang=js"
import style0 from "./Surgery.vue?vue&type=style&index=0&id=f6abe830&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6abe830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6abe830')) {
      api.createRecord('f6abe830', component.options)
    } else {
      api.reload('f6abe830', component.options)
    }
    module.hot.accept("./Surgery.vue?vue&type=template&id=f6abe830&scoped=true", function () {
      api.rerender('f6abe830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/Surgery.vue"
export default component.exports